import {createEntityAdapter, createSlice} from "@reduxjs/toolkit"
import {User} from "types/User"
import {fetchStaffUsers} from "./fetchStaffUsers"
import {StoreState} from "store"
import {useSelector} from "react-redux"
import {createStaffUser} from "./createStaffUser"
import {editStaffUser} from "./editStaffUser"
import {deleteStaffUser} from "./removeStaffUser"

export const staffAdapter = createEntityAdapter<User>()

export interface StateProps {
    loading: boolean
}

const initialState = staffAdapter.getInitialState<StateProps>({
    loading: true
})

const staffSlice = createSlice({
    name: "staff",
    initialState,
    reducers: {},
    extraReducers: builder => {
        // Вывод данных
        builder.addCase(fetchStaffUsers.pending, state => {
            state.loading = true
        })
        builder.addCase(fetchStaffUsers.fulfilled, (state, action) => {
            staffAdapter.setMany(state, action.payload.users)
            state.loading = false
        })
        builder.addCase(fetchStaffUsers.rejected, state => {
            state.loading = false
        })
        // Создать пользователя
        builder.addCase(createStaffUser.pending, state => {
            state.loading = true
        })
        builder.addCase(createStaffUser.fulfilled, (state, action) => {
            staffAdapter.setOne(state, action.payload.user)
            state.loading = false
        })
        builder.addCase(createStaffUser.rejected, state => {
            state.loading = false
        })
        // Изменить данные пользователя
        builder.addCase(editStaffUser.pending, state => {
            state.loading = true
        })
        builder.addCase(editStaffUser.fulfilled, (state, action) => {
            staffAdapter.setOne(state, action.payload.user)
            state.loading = false
        })
        builder.addCase(editStaffUser.rejected, state => {
            state.loading = false
        })
        // Удалить пользователя
        builder.addCase(deleteStaffUser.pending, state => {
            state.loading = true
        })
        builder.addCase(deleteStaffUser.fulfilled, (state, action) => {
            staffAdapter.removeOne(state, action.meta.arg)
            state.loading = false
        })
        builder.addCase(deleteStaffUser.rejected, state => {
            state.loading = false
        })
    }
})


export const {selectById, selectAll} = staffAdapter.getSelectors<StoreState>(
    state => state.staff
)

export default staffSlice.reducer

// Загрузка
export const useLoadingStaff = () => useSelector((state: StoreState) => state.staff.loading)

// Вывод всех сотрудников
export const useSelectAllStaff = () => useSelector(selectAll)

// Вывод сотрудника
export const useSelectStaffById = (id: User["id"]) => useSelector((state: StoreState) => selectById(state, id))
